<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title" style="text-align: center;">Amazon Connection Details</h4>
      <a href="#" @click.prevent="showMwsHelp()">Where do I get this?</a>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>MWS Auth Token</label>
              <input type="text"
                    name="mwsAuthToken"
                    class="form-control border-input"
                    placeholder="MWS Auth Token"
                    v-model="authDetails.account.data.mwsAuthToken"
                    v-validate="modelValidations.mwsAuthToken">
              <small class="text-danger" v-show="mwsAuthToken.invalid">
                {{ getError('mwsAuthToken') }}
              </small>
            </div>
            <div class="form-group">
              <label>Seller ID</label>
              <input type="text"
                    name="mwsSellerId"
                    class="form-control border-input"
                    placeholder="Selller ID"
                    v-model="authDetails.account.data.mwsSellerId"
                    v-validate="modelValidations.mwsSellerId">
              <small class="text-danger" v-show="mwsSellerId.invalid">
                {{ getError('mwsSellerId') }}
              </small>
            </div>
          </div>
        </div>
        
        <div class="text-center">
          <button v-if="!loading" type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="submit">
            Save
          </button>
          <button v-if="loading" type="submit" class="btn btn-info btn-fill btn-wd" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Save
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    props: {
      authDetails: {
        type: Object,
        required: true
      }
    },
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['mwsAuthToken',
        'mwsSellerId'])
    },
    data () {
      return {
        modelValidations: {
          mwsAuthToken: {
            required: true
          },
          mwsSellerId: {
            required: true
          }
        },
        loading: false
      }
    },
    methods: {
      showMwsHelp () {
        swal.fire({
          title: 'Amazon Connection Instructions',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: '<a target="_blank" href="https://sellercentral.amazon.com/apps/manage">Manage Your Apps</a> ' +
          'in Amazon Seller Central while logged in as the primary user. ' +
          'Click <strong>Authorize new developer</strong> and go through the workflow. ' +
          'Please use Developer Id <strong>2360-2313-2088</strong> and developer name ' +
          'Tech Legends'
        })
      },
      async updateMws () {
        try {
          let mwsDetails = {
            mwsSellerId: this.authDetails.account.data.mwsSellerId,
            mwsAuthToken: this.authDetails.account.data.mwsAuthToken
          }
          let result = await db.collection('accounts').doc(this.authDetails.account.id).update(mwsDetails)
          this.showNotify('Amazon API information saved.', 'success', 'Success')
          if ((mwsDetails.mwsAccessKeyId !== null && mwsDetails.mwsAccessKeyId !== '') &&
              (mwsDetails.mwsSecretAccessKey !== null && mwsDetails.mwsSecretAccessKey !== '')) {
            this.refreshAmazonProducts()
          }
          this.loading = false
        } catch (err) {
          this.showNotify(err, 'danger', 'Failed')
          this.loading = false
        }
      },
      submit () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateMws()
          } else {
            this.loading = false
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async refreshAmazonProducts () {
        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        let accountRefreshAmazonProds = firebase.functions().httpsCallable('accountRefreshAmazonProds')
        let result = await accountRefreshAmazonProds(data)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/EditMwsForm.vue